<template>
  <div class="detial-icongroup">
    <div style="width:3rem; float:left; ">
      <span class="text-uppercase world" v-if="detailData.categoryName" v-for="item in detailData.categoryName">{{item}}</span>
    </div>
    <div class="group">
      <span>
        <a
          class="tuite"
          href="https://twitter.com/share?text=shanghaieye&url=https://www.shanghaieye.com.cn/"
          target="_blank"
        >
          <img src="@/assets/imgs/detial/tuite.png" width="100%" alt="">
        </a>
      </span>
      <span>
        <a
          class="facebook"
          href="https://www.facebook.com/sharer.php?title=shanghaieye&u=https://www.shanghaieye.com.cn/"
          target="_blank"
        >
          <img src="@/assets/imgs/detial/facebook.png" width="100%" alt="">
        </a>
      </span>
      <span>
        <a
          class="sina"
          href="http://service.weibo.com/share/share.php?appkey=&title=shanghaieye3&url=https://www.shanghaieye.com.cn/"
          target="_blank"
        >
          <img src="@/assets/imgs/detial/sina.png" width="100%" alt="">
        </a>
      </span>
      <span class="bg-wx">
        <a class="wx" @click="showWx">
          <img src="@/assets/imgs/detial/weixin.png" width="100%" alt="">
        </a>
      </span>
      <img src="@/assets/imgs/detial/poster.png" alt class="joker" @click="showDialog" />
      <a class="v-line">|</a>

      <img src="@/assets/imgs/detial/joker.png" alt class="joker" v-if="status == 1" @click="setlikeFn(0)" />
      <img src="@/assets/imgs/detial/joker-g.png" alt class="joker" v-else @click="setlikeFn(1)" />

      <span :class="['num',{'num1':status==1}]">{{num}}</span>
      
    </div>
  </div>
</template>

<script>
import { setlike } from "@/network/details.js";
export default {
  name: "DetialIconGroup",
  data() {
    return {
      num: 0,
      categoryArr: [],
      status: 0,
      isOk: true,
    };
  },
  props: ["detailData", "postImg"],
  mounted() {
    // this.handleArr();
    this.num = this.detailData.numOfLikes;
    this.status = localStorage.getItem(this.detailData.postId);
    this.handleCategory();
  },
  methods: {
    handleCategory() {
      if (this.detailData) {
        this.detailData.categoryName = this.detailData.categoryName.split(",");
      }
    },
    setlikeFn(nub) {
      if (this.isOk) {
        this.isOk = false;
        this.status = nub;
        //取消点赞
        if (nub == 0) {
          localStorage.removeItem(this.detailData.postId);
        } else {
          //点赞
          localStorage.setItem(this.detailData.postId, nub);
        }
        setlike({ postId: this.detailData.postId, status: this.status })
          .then(res => {
            if (res.code == 200) {
              this.num = res.data;
            }
            this.isOk = true;
          })
          .catch(res => {
            this.isOk = true;
          });
      }
    },
    // detailData.categoryName
    showDialog() {
      this.$emit("showDialogFn");
    },
    showWx() {
      this.$emit("showWxFn");
    },
    handleArr() {
      // this.categoryArr = this.detailData.categoryName.split(",");
    },

    toPoster() {
      var system = {
        win: false,
        mac: false,
        xll: false,
      };

      //检测平台
      var p = navigator.platform;
      system.win = p.indexOf("Win") == 0;
      system.mac = p.indexOf("Mac") == 0;
      system.x11 = p == "X11" || p.indexOf("Linux") == 0;

      //跳转语句
      if (system.win || system.mac || system.xll) {
        //转向后台登陆页面
        // alert(1)
        // this.$message.error("请用手机生成海报！");
        var postUrl =
          "http://101.132.178.101:8001/poster.html?postId=" +
          this.$route.query.postId;
        window.location.href = postUrl;
        return;
      } else {
        var postUrl =
          "http://101.132.178.101:8001/wpindex/create/poster?postId=" +
          this.$route.query.postId;
        window.location.href = postUrl;
        // this.$router
        //   .push({
        //     path: "/poster",
        //     query: { postId: this.$route.query.postId },
        //   })
        //   .catch(err => {
        //     err;
        //   });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.detial-icongroup {
  &::after {
    content: "";
    clear: both;
    display: block;
  }
  // height: 1.5rem;
  padding: 0.3rem 0.5rem;
  line-height: 1.5rem;
  .world {
    background: #222222;
    font-size: 12px;
    color: #fff;
    font-family: FranklinGothic-Demi;
    font-weight: bold;
    cursor: pointer;
    float: left;
    line-height: 0.3rem;
    margin: 0.05rem;
    // padding: 0.12rem;
    padding: 0.12rem 0.2rem;
  }
  .group {
    float: right;
    display: flex;
    align-items: center;
    padding-top: 0.1rem;
  }
  a {
    float: right;
    height: 0.42rem;
    width: 0.47rem;
    margin: 0 0.1rem;
    cursor: pointer;
    img {
      display: block;
    }
  }

  .facebook {
    // background: url("~@/assets/imgs/detial/facebook.png") no-repeat;
    // background-size: 100% 100%;
  }
  .tuite {
    // background: url("~@/assets/imgs/detial/tuite.png") no-repeat;
    // background-size: 100% 100%;
  }
  .sina {
    // background: url("~@/assets/imgs/detial/sina.png") no-repeat;
    // background-size: 100% 100%;
  }
  .wx {
    // background: url("~@/assets/imgs/detial/weixin.png") no-repeat;
    // background-size: 100% 100%;
  }
  .v-line {
    font-size: 0.4rem;
    line-height: 0.4rem;
    text-align: center;
    color: #cccccc;
  }
  .joker {
    float: right;
    height: 0.48rem;
    width: 0.5rem;
    margin: 0 0.1rem;
    cursor: pointer;
  }
  .num {
    float: right;
    font-size: 0.4rem;
    line-height: 0.5rem;
    text-align: center;
    margin: 0 0.1rem;
    color: #676767;
    font-family: OpenSans;
  }
  .num1 {
    float: right;
    color: #936606;
  }
}
@media screen and (min-width: 768px) {
  .detial-icongroup {
    padding: 0.3rem 0;
    a {
      width: 0.36rem;
      height: 0.3rem;
    }
    .joker {
      float: right;
      height: 0.33rem;
      width: 0.36rem;
      margin: 0 0.1rem;
      cursor: pointer;
    }
    .num {
      float: right;
      font-size: 0.3rem;
      line-height: 0.21rem;
      text-align: center;
      margin: 0 0.1rem;
      color: #676767;
      font-family: OpenSans;
    }
    .num1 {
      float: right;
      color: #936606;
    }
    .v-line {
      font-size: 0.3rem;
      line-height: 0.2rem;
      text-align: center;
      color: #cccccc;
    }
    .world {
      background: #222222;
      // border-radius: 5px;
      font-size: 0.2rem;
      color: #fff;
      font-family: FranklinGothic-Demi;
      font-weight: bold;
      cursor: pointer;
      float: left;
      line-height: 0.2rem;
    }
  }
}
</style>